import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  page: {
    position: "absolute",
    width: "100%",
    height: "100%",
  },
  textDeco: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 24,
  },
  formArea: {
    display: "flex",
    justifyContent: "flex-end",
  },
  addingInfomationButton: {
    textTransform: "unset",
    fontSize: "12px",
    border: "none",
    color: "#4E65FF",
    ":hover": {
      border: "none",
      backgroundColor: "transparent",
    },
  },
  valueButton: {
    width: "45%",
    height: "50px",
    borderRadius: 12,
    fontWeight: 700,
    fontSize: "16px",
  },
}));

export default useStyles;
